import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

Injectable({
    providedIn: 'root'
});
export class AppointmentListActions {

    static setViewDeletedReminders = createAction('[Reminders:AppointmentList] Set View Deleted Reminders', props<{ payload: boolean }>());

    static setViewVoidAppointments = createAction('[Reminders:AppointmentList] Set View Void Reminders', props<{ payload: boolean }>());

    static setPageType = createAction('[Reminders:AppointmentList] Set Page Type to avoid conflict of data', props<{ payload: string }>());


    static openAppointmentLogsFromLogsJS = createAction('[Logs:AppointmentLog] Open Appointment Logs',
        props<{ appointment: any, dialogType: any , selectedMessage: any , userTimeZone: any, userPermissionKeys: any}>());

    static openAppointmentLogsFromAppointmentList = createAction('[Reminders:AppointmentList:AppointmentLog] Open Appointment Logs',
        props<{ appointment: any, dialogType: any , selectedMessage: any, userTimeZone: any, userPermissionKeys: any}>());
}
